import { foursquareUri } from '@coin-microservices/foursquare-react-hooks'

import { makeApolloAuthProvider } from './apollo'

const uri = process.env.NODE_ENV === 'development' ? 'http://localhost:4000' : foursquareUri

export const FoursquareProvider = makeApolloAuthProvider(uri)
